<p-dialog
  (onHide)="onHide()"
  [contentStyle]="{padding: '30px'}"
  [(visible)]="visible"
  [blockScroll]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [style]="{ width: '70%', height: '90%', maxWidth: '100%' }"
  appendTo="body"
  header="Embed on your website"
  maskStyleClass="embed-code-dialog-mask"
  styleClass="thank-you-dialog custom-width-dialog mi-mob-fullscreen-dialog embed-code-dialog">
  <div class="embed-code-body">
    <p class="embed-code-hint">
      Paste the code below into your website where you want the card to appear.
      The loader script handles dialog overflow automatically.
    </p>

    <div class="flex mb-3">
      <p-selectbutton [(ngModel)]="embededSize" (ngModelChange)="versionChange($event)" [options]="cardSizes" [allowEmpty]="false" />
    </div>
    <div class="flex" [class.flex-column]="isMobile">
      <div class="flex-1">
        <div class="embed-code-section">
          @if(embededSize === 'Responsive (Advanced)')
          {
            <p-message class="my-3" severity="warn" icon="pi pi-sliders-h" [closable]="false">You may need to adjust the iframe dimensions and styles for your use case.</p-message>
          }
          @else 
          {
            <p-message class="my-3" severity="warn" icon="pi pi-sliders-h" [closable]="false">You can adjust size of card by changing height attribute.</p-message>
          }

          <div class="mt-3 embed-code-label-row">
            <span class="embed-code-label">Embed code</span>
            <button
              #copySnippetBtn
              class="copy-link-btn"
              type="button"
              (click)="copyEmbedText(iframeEmbedCode, copySnippetBtn)">
              Copy
            </button>
          </div>
          <pre class="embed-code-block">{{ iframeEmbedCode }}</pre>
        </div>

        <div class="embed-code-section">
          <div class="embed-code-label-row">
            <span class="embed-code-label">Loader script URL</span>
            <button
              #copyLoaderBtn
              class="copy-link-btn"
              type="button"
              (click)="copyEmbedText(loaderScriptUrl, copyLoaderBtn)">
              Copy
            </button>
          </div>
          <pre class="embed-code-block">{{ loaderScriptUrl }}</pre>
        </div>
      </div>
      <div class="flex-1 relative min-h-30rem">
        @if(showEmbeded() && safeUrl)
        {
          <iframe style="pointer-events: none; min-height: 400px"
                  [ngClass]="embededSize === 'Responsive (Advanced)' && 'absolute-center'"
                  [src]="safeUrl"
                  data-pitchcard-embed="true"
                  allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
                  width="100%"
                  [height]="embededSize === 'Small' 
                      ? '400px' 
                      : embededSize === 'Medium' 
                      ? '500px' 
                      : embededSize === 'Large'
                      ? '550px'
                      : '100%'"
                  frameborder="0" allowfullscreen></iframe>
        }
      </div>
    </div>
  </div>
</p-dialog>
